// extracted by css-extract-rspack-plugin
export default {"stepIndicator":"UiStepperStep_stepIndicator_VwIad"};